var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"},on:{":after-leave":_vm.animationFinished}},[_c('nav',{staticClass:"HeaderAccountNavContent"},[_c('account-nav',{staticClass:"HeaderAccountNavContent-list",attrs:{"accountNav":_vm.accountNav}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }